
import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { GrossMassContainerModel } from "./gross-mass-container-dto";


export class GrossMassResponseModel extends GlobalResponseObject{
    data?: GrossMassContainerModel[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data string
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: GrossMassContainerModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}